import isNil from 'lodash/isNil';
import { createPortal } from 'react-dom';

import { Div } from '@ui/components/base/div';
import { SPOTLIGHT_RING_WIDTH, type SpotlightBox } from '@ui/components/tour/tourUtils';
import { cn } from '@ui/lib/utils';
import { ZIndex } from '@ui/zIndexUtils';

const SPOTLIGHT_SHADOW = `0 0 0 ${SPOTLIGHT_RING_WIDTH}px var(--primary), 0 0 0 9999px var(--tour-dim)`;

const SPOTLIGHT_LAYER_STYLE = { zIndex: ZIndex.TOUR_SPOTLIGHT };

interface ProductTourSpotlightProps {
  box: SpotlightBox | null;
  moving: boolean;
}

const ProductTourSpotlight = ({ box, moving }: ProductTourSpotlightProps) =>
  createPortal(
    isNil(box) ? (
      <Div
        key="searching"
        aria-hidden
        data-slot="product-tour-spotlight"
        data-state="searching"
        className="pointer-events-none fixed inset-0 bg-(--tour-dim)"
        style={SPOTLIGHT_LAYER_STYLE}
      />
    ) : (
      <Div
        key="spotlight"
        aria-hidden
        data-slot="product-tour-spotlight"
        data-state={moving ? 'moving' : 'spotlight'}
        className={cn(
          'pointer-events-none fixed rounded-xl',
          moving && 'transition-[top,left,width,height] duration-300 ease-in-out'
        )}
        style={{ ...box, ...SPOTLIGHT_LAYER_STYLE, boxShadow: SPOTLIGHT_SHADOW }}
      />
    ),
    document.body
  );

export { ProductTourSpotlight };
